export enum BusinessScope {
  FGDS = "FGDS",
  MONITORING = "MONITORING",
}
